define([
    'text!product-detail/component/spec-info.html',
    'product-detail/mixin/product',
    'product-detail/component/size-image',
    'lodash',

    'css!product-detail/component/spec-info.css'
], function(
    tpl,
    ProductMixin,
    SizeImage,
    _
){
    var items = [
        {icon:'u-icon-ruler',title:'产品参数 Product Parameter',field: 'sizeText'},
        {icon:'u-icon-hand',title:'材质 Material',field: 'materialText'},
        {icon:'u-icon-marker',title:'产地 Production Place',field: 'areaText'},
        {icon:'u-icon-wrench',title:'安装方式 Installation Method',field: 'installText'}
    ];
    return {
        template: tpl,
        components: {
            SizeImage: SizeImage
        },
        mixins: [ProductMixin],
        data: function(){
            return {
                items: items
            };
        },
        computed: {
            sizeImages: function(){
                return this.selectedSkuExtra.sizeImages || [];
            },
            isAnimate: function(){
                return this.isFurniture && this.sizeImages.length > 1;
            }
        },
        watch: {
            selectedSku: 'updateItems'
        },
        methods: {
            updateItems: function(){
                var _this = this;
                _.forEach(this.items, function(o){
                    o.desc = _this.selectedSkuExtra[o.field];
                });
            }
        },
        created: function(){
            this.updateItems();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/spec-info.js
// module id = 142
// module chunks = 0